import React, { useMemo } from "react";
import DOMPurify from "dompurify";

interface Props {
  html: string;
  className?: string;
}

/**
 * Renderiza HTML vindo do backend de forma segura, sanitizando o conteúdo com
 * DOMPurify antes de injetá-lo no DOM.
 */
export default function SafeHtml({ html, className }: Props) {
  const sanitized = useMemo(() => DOMPurify.sanitize(html || ""), [html]);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
